// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-comfy -> weidner-apartment-homes-theme-comfy -> dakota-commons-apartment-homes
// Generated: 2026-11-04T21:28:05.292Z
// Counts: 0 design, 39 content, 18 slot group, 0 collection binding, 7 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.hours_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Office Hours</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.office_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Leasing Office</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.talk_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Let's Talk</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Spacious Apartment Layouts</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Gallery</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome To <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Williston's Area</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Life at Dakota Commons</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1><h1></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Dakota Commons in Williston, ND, enjoy everyday living with a suite of comfortable in-home and community features. Your apartment offers the essentials: extra-large closets, walk-in closets, washer and dryer, dishwasher, microwave, garbage disposal, and air conditioning ports. The laundry room, with a folding table and ample storage, adds convenience. Just outside, the pet-friendly community offers a garage, controlled access, and a smoke-free environment. On-site management, online services, and emergency maintenance keep life running smoothly.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Have questions or want to learn more about Dakota Commons in Williston, ND? Our friendly leasing team is here to help you with availability, tours, and resident support. Reach out any time for more details or to plan your visit.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover a floor plan designed for your lifestyle at Dakota Commons. Choose from one-, two-, or three-bedroom layouts, each with spacious closets, space for work or relaxation, ample storage, and the convenience of your own parking garage. The mix of open living spaces and extra room for your belongings makes it easy to work from home or entertain friends.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from one-, two-, or three-bedroom homes in Williston, ND.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Browse our gallery and picture your daily routine at Dakota Commons Apartments. Enjoy upgraded kitchens, cozy living areas, and the simple luxury of in-home laundry. Glance through images of our community spaces and see how comfort and convenience blend naturally here in Williston, ND. If you feel drawn in, take a virtual tour or schedule a visit and imagine your own style in these inviting spaces.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Warm and welcoming apartment homes in Williston, ND</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Dakota Commons Apartment Homes brings the best of Williston to your doorstep. Grab pizza at Pizza Hut, connect at Applebee's Grill and Bar, or pick up groceries at Walmart just around the corner. You'll be near the action - local spots like ARC Parks &amp; Recreation, the Frontier Museum, and Williston Basin Hockey Club make weekends fun. For quick getaways, Highway 2 and 1804 are close, making drives across town and beyond seamless. With dining, shopping, and entertainment nearby, life here flows with ease and possibility.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Dakota Commons keeps you close to Williston Brewing Company, shops, and quick-bite options like Crazy Cravings. With easy access to US 2 and Highway 1804, your commutes or trips downtown are a breeze. Enjoy living minutes from downtown fun, local employers, and city recreation spots. Dinner with friends, groceries, or errands - life runs smoother from your Dakota Commons home base.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Looking for apartments for rent in Williston, ND? At Dakota Commons, unwind in your roomy home with a private garage and space for your pets. Morning coffee on your sofa, evening strolls through friendly community paths - comfort follows you. Whether you're a homebody or out exploring Williston, Dakota Commons combines everyday convenience with vibrant community energy near Walmart and Tractor Supply.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose your preferred way to explore Dakota Commons. Schedule an in-person or live virtual tour guided by our leasing team, or check out a virtual walkthrough at your own pace. No matter how you visit, we'll help you see how these open, comfortable homes and convenient features fit your lifestyle. Touring restrictions may apply.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Walk through Dakota Commons Apartments from your couch or wherever you are. Our virtual tour makes it easy to imagine how you'd arrange your living space, where you'd have coffee, or how you'd wind down at night. Use this online view to catch the atmosphere, sense the layouts, and get a feel for the Dakota Commons lifestyle before you come in. From kitchens to gathering spots, you can explore it all at your own pace.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "customValue": "/apply-now",
        "mappedField": "property_apply_now_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "hero.feature_slide_3": {
    "sourceIndex": 0,
    "fieldOverrides": null
  },
  "footer.get_in_touch_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "amenities-hero.bg_image": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "floor-plans-hero.bg_image": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "gallery-hero.bg_image": {
    "sourceIndex": 2,
    "fieldOverrides": null
  },
  "hero.feature_slide_1": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "hero.feature_slide_2": {
    "sourceIndex": 9,
    "fieldOverrides": null
  },
  "hero.feature_slide_4": {
    "sourceIndex": 2,
    "fieldOverrides": null
  },
  "hero.feature_slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5752423586988032/019d01a2-2782-758a-bfcf-2c5143d6b58d.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with dark wood cabinets, stainless steel appliances, and an island with a breakfast bar."
      }
    }
  },
  "propertyoverview.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a1-857f-7751-a1a5-f8a69279383a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with two sofas, coffee table, rug, and a balcony view."
      }
    }
  },
  "propertyoverview.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a1-8724-7663-8250-d8fb7044fe32.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen and dining area with stainless steel appliances, ample cabinet space, and an island."
      }
    }
  },
  "propertyoverview.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a1-d188-7177-bf57-a87c9b596144.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of apartment buildings with beige and brown siding, manicured lawns, and streetlights."
      }
    }
  },
  "residentaccess.payrent_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a1-8724-7663-8250-d8fb7044fe32.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen and dining area with stainless steel appliances, ample cabinet space, and an island."
      }
    }
  },
  "residentaccess.portal_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a1-871f-73ae-a341-eb179cf0de5d.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Cozy bedroom with a queen-sized bed, nightstands, and a comfortable accent chair."
      }
    }
  },
  "residentaccess.service_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5752423586988032/019d01a1-857f-7751-a1a5-f8a69279383a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with two sofas, coffee table, rug, and a balcony view."
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
